module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-acknowledgments element-with-heading",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "acknowledgments-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Acknowledgments")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "acknowledgments-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Special thanks goes out to: The Creator from whom all Blessings and opportunities flow, Sandy (my true mother), my son, J. L. Woodson (for the awesome cover designs for this Merry Hearts series), Sesvalah, Bettye Odom, Janice M. Allen, Debra J. Mitchell, Royce Slade Morton, Bunny Ervin, J. L. Campbell, Kelly Peterson, Janine A. Ingram, Ehryck F. Gilmore, Betty Clawson, Jamyi Joy, Stephanie M. Freeman, Unique Hiram, Marie L. McKenzie, Shawn Williams, Dr. Vanessa Howard, the Kings of the Castle Ambassadors, Members of Naleighna Kai’s Literary Cafe, the members of NK’s Tribe Called Success, the members of Namakir Tribe, and to you, my dear readers . . . thank you all for your support.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Much love, peace, and joy,")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Naleighna Kai")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("NAMAKIR Tribe Members:")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Naleighna Kai    ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("J. L. Woodson")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Janice M. Allen ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Martha Kennerson")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("J. L. Campbell")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Marze Scott")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Karen D. Bradley ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sierra Kay")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Shakir Rashaan")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Pat G’Orge-Walker")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Anita L. Roseboro")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Michelle D. Rayford")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Florenza Denise Lee")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Stephanie Freeman")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lisa Dodson")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Terri Ann Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Christine Pauls")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Unique M. Hiram ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("J. S. Cole")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sekinah Jackson")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Solsire E. Felida")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Marie McKenzie")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Vanessa Howard")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Kadesha Powell")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Erica B. Davis")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Brynn Weimer")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Angela Lackey ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('b', [_vm._v("NAMASTE Tribe members ")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Janine Ingram")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Bridgett McGill")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lizabeth Harris")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lori Hays")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Yolanda Cranford")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Bridgett Renay")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Carol Jones")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lucille Freeman")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Catherine Roberts")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Randi Coley")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Allita Irby")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e992ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgments.vue
// module id = 75
// module chunks = 0